import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './StaticNavigation.css';
import Menu from '../Menu';
import StaticTitle from './StaticTitle';
import Logos from '../Logos';

const StaticNavigation = ({ title }) => (
  <div className={styles.containerWrap}>
    <Menu />
    <div className={styles.container}>
      <div className={styles.navigation}>
        <StaticTitle title={title} />
      </div>
    </div>
    <Logos smallLogos />
  </div>
);

StaticNavigation.propTypes = {
  title: PropTypes.string.isRequired,
};

export default StaticNavigation;



// WEBPACK FOOTER //
// ./src/components/StaticPages/StaticNavigation.jsx